import { useMediaQuery } from "react-responsive";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { DeviceSize } from "../../utils/constants";

export default function BarCharts({ data }: any) {
  const isMobile = useMediaQuery({ maxWidth: DeviceSize.mobile });

  return (
    <BarChart
      width={isMobile ? 325 : 400}
      height={isMobile ? 250 : 300}
      data={data}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip />
      <Legend />
      <Bar dataKey="uv" name="Maximum" fill="#82ca9d" />
      <Bar dataKey="pv" fill="#8884d8" name="Minimum" />
      <Bar dataKey="cv" fill="#ff0000" name="Median" />
    </BarChart>
  );
}
